import sunset from '../../imgs/diego_sunset.jpg'
import beach from '../../imgs/beach_party.jpg'
import { FiDroplet, FiHome, FiSun, FiUsers } from 'react-icons/fi'


const TabContact = () => {
    return (
        <div className='tab-wrapper'>
            <section className='page-hero about-hero'>
                <img className='hero-image' src={sunset} alt="A colorful winter sunset over Greenwood Lake" />
                <div className='hero-shade'></div>
                <div className='hero-content'>
                    <span className='eyebrow'>Our story</span>
                    <h1>A community shaped by neighbors.</h1>
                    <p>For generations, Indian Park residents have cared for this special corner of Greenwood Lake together.</p>
                </div>
            </section>

            <section className='page-section about-section'>
                <div className='about-story'>
                    <div className='about-copy'>
                        <span className='eyebrow dark'>Since 1936</span>
                        <h2>Independent by tradition.<br />Connected by choice.</h2>
                        <p>Indian Park is a private, self-sufficient community run entirely by volunteers. What began with gravel roads and summer-only water has grown into a year-round neighborhood while keeping its close-knit spirit.</p>
                        <p>Some homes are still held by families whose connection to Indian Park reaches back to its incorporation — a living thread between the community’s past and future.</p>
                    </div>
                    <div className='about-photo'>
                        <img src={beach} alt="Neighbors gathering at an Indian Park community beach" />
                        <span>Community at the water’s edge</span>
                    </div>
                </div>

                <div className='fact-grid'>
                    <article><FiHome /><strong>Founded in 1936</strong><p>Nearly a century of shared history on Greenwood Lake.</p></article>
                    <article><FiUsers /><strong>Volunteer powered</strong><p>Residents work together to care for the community.</p></article>
                    <article><FiSun /><strong>Two shared beaches</strong><p>Community-owned places to gather and enjoy the lake.</p></article>
                    <article><FiDroplet /><strong>Built to last</strong><p>From summer water and gravel roads to a year-round home.</p></article>
                </div>
            </section>
        </div>
    )
}
export default TabContact
